import React from 'react';
import { formatPrice } from '../../../../utils';

const KatlamaliSettings = React.memo(({
  katlamaliExtras,
  setKatlamaliExtras,
  isKatlamaliMekanizmaCollapsed,
  setIsKatlamaliMekanizmaCollapsed,
  newKatlamaliMekanizma,
  setNewKatlamaliMekanizma,
  handleSaveSettings,
  isSavingSettings
}) => {
  const [editingId, setEditingId] = React.useState(null);

  const handleAddOrUpdate = () => {
    if (!newKatlamaliMekanizma.type.trim() || !newKatlamaliMekanizma.price) return;
    
    const currentList = katlamaliExtras.mekanizmaList || [];
    let newList;
    
    if (editingId) {
      newList = currentList.map(m => m.id === editingId ? {
        ...m,
        type: newKatlamaliMekanizma.type.trim(),
        price: parseFloat(newKatlamaliMekanizma.price)
      } : m);
    } else {
      newList = [...currentList, {
        id: Date.now().toString(),
        type: newKatlamaliMekanizma.type.trim(),
        price: parseFloat(newKatlamaliMekanizma.price)
      }];
    }
    
    setKatlamaliExtras({ ...katlamaliExtras, mekanizmaList: newList });
    handleSaveSettings({ katlamaliMekanizmaList: newList });
    setNewKatlamaliMekanizma({ type: '', price: '' });
    setEditingId(null);
  };

  return (
    <>
      <div className="settings-card" style={{ marginBottom: '20px' }}>
        <div className="settings-card-title">
          <i className="fas fa-cogs"></i>
          <h4>Motor Ayarları</h4>
          <button className="btn-save" onClick={() => handleSaveSettings()} disabled={isSavingSettings}>
            {isSavingSettings ? '...' : 'Kaydet'}
          </button>
        </div>
        <div className="settings-grid">
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label>Motor Döviz Kuru</label>
            <select value={katlamaliExtras.motorCurrency} onChange={(e) => setKatlamaliExtras(p => ({ ...p, motorCurrency: e.target.value }))}>
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
              <option value="TRY">TRY</option>
            </select>
          </div>
          <div className="form-group" style={{ marginBottom: 0 }}>
            <label>Motor Ücreti</label>
            <input type="number" value={katlamaliExtras.motorPrice} onChange={(e) => setKatlamaliExtras(p => ({ ...p, motorPrice: e.target.value }))} />
          </div>
        </div>
      </div>
      <div className="settings-card" style={{ marginBottom: '20px' }}>
        <div className="settings-card-title">
          <i className="fas fa-tools"></i>
          <h4>Katlamalı Perde Mekanizma Ayarları</h4>
        </div>

        <div style={{ width: '100%' }}>
          <div
            onClick={() => setIsKatlamaliMekanizmaCollapsed(!isKatlamaliMekanizmaCollapsed)}
            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', marginBottom: '10px' }}
          >
            <h4 style={{ margin: 0, fontSize: '14px', color: '#334155' }}>Mekanizma Tipleri ve Ücretleri</h4>
            <i className={`fas fa-chevron-${isKatlamaliMekanizmaCollapsed ? 'down' : 'up'}`} style={{ color: '#64748b', fontSize: '12px' }}></i>
          </div>

          {!isKatlamaliMekanizmaCollapsed && (
            <div className="mekanizma-list-content" style={{ animation: 'slideDown 0.3s ease-out' }}>
              <div style={{ display: 'flex', gap: '10px', marginBottom: '15px', width: '100%', flexWrap: 'wrap' }}>
                <input
                  type="text"
                  placeholder="Mekanizma Tipi (Örn: 5+1)"
                  value={newKatlamaliMekanizma.type}
                  onChange={(e) => setNewKatlamaliMekanizma({ ...newKatlamaliMekanizma, type: e.target.value })}
                  style={{ flex: 2, minWidth: '150px', padding: '8px', border: '1px solid #cbd5e1', borderRadius: '4px' }}
                />
                <input
                  type="number"
                  placeholder="Ücret (₺)"
                  value={newKatlamaliMekanizma.price}
                  onChange={(e) => setNewKatlamaliMekanizma({ ...newKatlamaliMekanizma, price: e.target.value })}
                  style={{ flex: 1, minWidth: '100px', padding: '8px', border: '1px solid #cbd5e1', borderRadius: '4px' }}
                />
                <button
                  onClick={handleAddOrUpdate}
                  style={{ padding: '8px 15px', backgroundColor: '#b04309', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                >
                  {editingId ? 'Güncelle' : 'Ekle'}
                </button>
                {editingId && (
                  <button
                    onClick={() => {
                      setEditingId(null);
                      setNewKatlamaliMekanizma({ type: '', price: '' });
                    }}
                    style={{ padding: '8px 15px', backgroundColor: '#64748b', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                  >
                    Vazgeç
                  </button>
                )}
              </div>

              {katlamaliExtras.mekanizmaList && katlamaliExtras.mekanizmaList.length > 0 ? (
                <ul style={{ listStyle: 'none', padding: 0, margin: 0, maxHeight: '250px', overflowY: 'auto', border: '1px solid #e2e8f0', borderRadius: '4px', maxWidth: '500px', backgroundColor: 'white' }}>
                  {katlamaliExtras.mekanizmaList.map((mek, idx) => (
                    <li key={mek.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 12px', borderBottom: idx < katlamaliExtras.mekanizmaList.length - 1 ? '1px solid #e2e8f0' : 'none', alignItems: 'center' }}>
                      <div style={{ flex: 1 }}>
                        <span style={{ fontSize: '14px', fontWeight: '500', color: '#1e293b' }}>{mek.type}</span>
                        <span style={{ fontSize: '13px', color: '#64748b', marginLeft: '10px' }}>{formatPrice(mek.price)} ₺</span>
                      </div>
                      <div style={{ display: 'flex', gap: '10px' }}>
                        <button
                          onClick={() => {
                            setEditingId(mek.id);
                            setNewKatlamaliMekanizma({ type: mek.type, price: mek.price });
                          }}
                          style={{ background: 'none', border: 'none', color: '#b04309', cursor: 'pointer', padding: '4px' }}
                          title="Düzenle"
                        >
                          <i className="fas fa-edit"></i>
                        </button>
                        <button
                          onClick={() => {
                            const newList = katlamaliExtras.mekanizmaList.filter(m => m.id !== mek.id);
                            setKatlamaliExtras({ ...katlamaliExtras, mekanizmaList: newList });
                            handleSaveSettings({ katlamaliMekanizmaList: newList });
                          }}
                          style={{ background: 'none', border: 'none', color: '#ef4444', cursor: 'pointer', padding: '4px' }}
                          title="Sil"
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <p style={{ fontSize: '13px', color: '#64748b', margin: 0 }}>Henüz mekanizma tipi eklenmemiş.</p>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
});

export default KatlamaliSettings;
